export default __webpack_public_path__ + "static/media/hoseg4.c550292d.jpg";